export const OIDC_CONFIG = {
  authority: String(process.env.REACT_APP_OIDC_CONFIG_AUTHORITY),
  client_id: String(process.env.REACT_APP_OIDC_CONFIG_CLIENT_ID),
  redirect_uri: String(process.env.REACT_APP_OIDC_CONFIG_REDIRECT_URL),
  scope: String(process.env.REACT_APP_OIDC_CONFIG_SCOPE),
  response_type: String(process.env.REACT_APP_OIDC_CONFIG_RESPONSE_TYPE),
  client_secret: String(process.env.REACT_APP_OIDC_CONFIG_CLIENT_SECRET),
};
